import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material/styles'; 
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

export const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
     theme.palette.mode === 'light'
            ? `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(theme.palette.secondary.light, 0.1)} 50%, transparent 100%)`
            : `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.2)} 0%, ${alpha(theme.palette.secondary.dark, 0.2)} 50%, transparent 100%)`,
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));
// NFT Card Style for ERC1155 tokens
export const NFTCardStyle = styled('div')(({ theme, sx }) => ({
  boxShadow: theme.palette.mode === 'light' 
    ? `0px 12px 40px ${alpha(theme.palette.primary.main, 0.15)}` 
    : `0px 12px 40px ${alpha('#000000', 0.3)}`,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  background: theme.palette.mode === 'light' 
    ? theme.palette.background.nftCard || 'white'
    : theme.palette.background.nftCard || theme.palette.background.paper,
  border: `2px solid ${theme.palette.mode === 'light' 
    ? alpha(theme.palette.primary.main, 0.1) 
    : alpha(theme.palette.primary.light, 0.2)}`,
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  overflow: 'hidden',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.gradients?.nftBrand || theme.palette.gradients?.primary,
    opacity: 0,
    transition: 'opacity 0.3s ease',
    pointerEvents: 'none',
  },
  '&:hover': {
    transform: 'translateY(-8px) scale(1.02)',
    boxShadow: theme.palette.mode === 'light'
      ? `0px 20px 60px ${alpha(theme.palette.primary.main, 0.25)}`
      : `0px 20px 60px ${alpha('#000000', 0.4)}`,
    '&::before': {
      opacity: 0.05,
    },
  },
  ...sx,
}));

export const CardStyle = styled('div')(({ theme, sx }) => ({
  boxShadow: theme.palette.mode === 'light' 
    ? `0px 2px 3px ${alpha(theme.palette.primary.main, 0.15)}` 
    : `0px 2px 3px ${alpha('#000000', 0.3)}`,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  background: theme.palette.mode === 'light' 
    ? theme.palette.background.nftCard || 'white'
    : theme.palette.background.nftCard || theme.palette.background.paper,
  border: `2px solid ${theme.palette.mode === 'light' 
    ? alpha(theme.palette.primary.main, 0.1) 
    : alpha(theme.palette.primary.light, 0.2)}`,
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  overflow: 'hidden',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.gradients?.nftBrand || theme.palette.gradients?.primary,
    opacity: 0,
    transition: 'opacity 0.3s ease',
    pointerEvents: 'none',
  },
  // '&:hover': {
  //   transform: 'translateY(-8px) scale(1.02)',
  //   boxShadow: theme.palette.mode === 'light'
  //     ? `0px 2px 3px ${alpha(theme.palette.primary.main, 0.16)}`
  //     : `0px 2px 3px ${alpha('#000000', 0.4)}`,
  //   '&::before': {
  //     opacity: 0.05,
  //   },
  // },
  ...sx,
}));

// Trading Panel Style
export const TradingPanelStyle = styled('div')(({ theme, sx }) => ({
  background: theme.palette.mode === 'light'
    ? theme.palette.background.tradingPanel || `linear-gradient(135deg, ${alpha(theme.palette.primary.lighter, 0.5)}, ${alpha(theme.palette.accent?.lighter || theme.palette.secondary.lighter, 0.5)})`
    : theme.palette.background.tradingPanel || `linear-gradient(135deg, ${alpha(theme.palette.primary.darker, 0.2)}, ${alpha(theme.palette.accent?.darker || theme.palette.secondary.darker, 0.2)})`,
  borderRadius: '20px',
  padding: '24px',
  border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
  boxShadow: `0px 8px 32px ${alpha(theme.palette.primary.main, 0.1)}`,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.gradients?.blockchain || theme.palette.gradients?.primary,
    opacity: 0.03,
    pointerEvents: 'none',
  },
  ...sx,
}));

// Marketplace Container
export const MarketplaceStyle = styled('div')(({ theme, sx }) => ({
  background: theme.palette.mode === 'light'
    ? theme.palette.background.marketplace || `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)}, ${alpha(theme.palette.secondary.main, 0.05)})`
    : theme.palette.background.marketplace || `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.15)}, ${alpha(theme.palette.secondary.dark, 0.15)})`,
  minHeight: '100vh',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `radial-gradient(circle at 20% 30%, ${alpha(theme.palette.primary.main, 0.1)} 0%, transparent 50%),
                 radial-gradient(circle at 80% 70%, ${alpha(theme.palette.accent?.main || theme.palette.secondary.main, 0.1)} 0%, transparent 50%)`,
    pointerEvents: 'none',
  },
  ...sx,
}));

// Price Tag Style
export const PriceTagStyle = styled('div')(({ theme, featured, sx }) => ({
  background: featured 
    ? theme.palette.gradients?.nftBrand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.accent?.main || theme.palette.secondary.main})`
    : theme.palette.mode === 'light' ? alpha(theme.palette.grey[100], 0.8) : alpha(theme.palette.grey[800], 0.8),
  color: featured ? 'white' : theme.palette.text.primary,
  padding: '8px 16px',
  borderRadius: '12px',
  fontWeight: 600,
  fontSize: '14px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  boxShadow: featured
    ? `0px 4px 16px ${alpha(theme.palette.primary.main, 0.3)}`
    : `0px 2px 8px ${alpha(theme.palette.grey[500], 0.1)}`,
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: featured
      ? `0px 6px 20px ${alpha(theme.palette.primary.main, 0.4)}`
      : `0px 4px 12px ${alpha(theme.palette.grey[500], 0.15)}`,
  },
  ...sx,
}));

// Blockchain Badge
export const BlockchainBadgeStyle = styled('div')(({ theme, chain, sx }) => {
  const getChainColors = (chainName) => {
    switch(chainName?.toLowerCase()) {
      case 'ethereum':
        return { bg: '#627eea', text: '#fff' };
      case 'polygon':
        return { bg: '#8247e5', text: '#fff' };
      case 'bsc':
        return { bg: '#f3ba2f', text: '#000' };
      default:
        return { bg: theme.palette.primary.main, text: '#fff' };
    }
  };
  
  const colors = getChainColors(chain);
  
  return {
    background: colors.bg,
    color: colors.text,
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    boxShadow: `0px 2px 8px ${alpha(colors.bg, 0.3)}`,
    ...sx,
  };
});

// Trading Button
export const TradingButtonStyle = styled('button')(({ theme, variant = 'primary', sx }) => {
  const getVariantStyles = () => {
    switch(variant) {
      case 'buy':
        return {
          background: theme.palette.gradients?.nftBrand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.accent?.main || theme.palette.secondary.main})`,
          color: 'white',
          '&:hover': {
            background: theme.palette.gradients?.nftBrandReverse || `linear-gradient(135deg, ${theme.palette.accent?.main || theme.palette.secondary.main}, ${theme.palette.primary.main})`,
          },
        };
      case 'sell':
        return {
          background: `linear-gradient(135deg, ${theme.palette.warning.main}, ${theme.palette.error.main})`,
          color: 'white',
          '&:hover': {
            background: `linear-gradient(135deg, ${theme.palette.error.main}, ${theme.palette.warning.main})`,
          },
        };
      case 'bid':
        return {
          background: `linear-gradient(135deg, ${theme.palette.info.main}, ${theme.palette.primary.main})`,
          color: 'white',
          '&:hover': {
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.info.main})`,
          },
        };
      default:
        return {
          background: theme.palette.gradients?.primary || theme.palette.primary.main,
          color: 'white',
        };
    }
  };
  
  return {
    ...getVariantStyles(),
    border: 'none',
    borderRadius: '12px',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: `0px 4px 16px ${alpha(theme.palette.primary.main, 0.2)}`,
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: `0px 8px 24px ${alpha(theme.palette.primary.main, 0.3)}`,
    },
    '&:active': {
      transform: 'translateY(0px)',
    },
    '&:disabled': {
      background: theme.palette.grey[300],
      color: theme.palette.grey[500],
      cursor: 'not-allowed',
      transform: 'none',
      boxShadow: 'none',
    },
    ...sx,
  };
});

// Collection Header
export const CollectionHeaderStyle = styled('div')(({ theme, sx }) => ({
  background: theme.palette.gradients?.tradingGlow || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main}, ${theme.palette.accent?.main || theme.palette.primary.dark})`,
  borderRadius: '24px',
  padding: '32px',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `radial-gradient(circle at 30% 20%, ${alpha('#ffffff', 0.2)} 0%, transparent 50%)`,
    pointerEvents: 'none',
  },
  ...sx,
}));

// Stats Card for marketplace metrics
export const StatsCardStyle = styled('div')(({ theme, sx }) => ({
  background: theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper,
  borderRadius: '16px',
  padding: '24px',
  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  boxShadow: `0px 8px 32px ${alpha(theme.palette.primary.main, 0.08)}`,
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: `0px 16px 48px ${alpha(theme.palette.primary.main, 0.12)}`,
    borderColor: alpha(theme.palette.primary.main, 0.2),
  },
  ...sx,
}));

// Search Bar for NFT marketplace
export const NFTSearchBarStyle = styled('div')(({ theme, sx }) => ({
  borderRadius: 16,
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  background: theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper,
  boxShadow: `0px 8px 32px ${alpha(theme.palette.primary.main, 0.1)}`,
  border: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:focus-within': {
    boxShadow: `0px 12px 40px ${alpha(theme.palette.primary.main, 0.2)}`,
    borderColor: theme.palette.primary.main,
    transform: 'translateY(-2px)',
  },
  '& input': {
    border: 'none',
    flex: 1,
    padding: '16px 20px',
    fontSize: '16px',
    background: 'transparent',
    color: theme.palette.text.primary,
    '&:focus, &:active': {
      outline: 'none',
    },
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
  },
  '& button': {
    background: theme.palette.gradients?.nftBrand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.accent?.main || theme.palette.secondary.main})`,
    border: 'none',
    padding: '16px 24px',
    color: 'white',
    cursor: 'pointer',
    fontWeight: 600,
    transition: 'all 0.3s ease',
    '&:hover': {
      background: theme.palette.gradients?.nftBrandReverse || `linear-gradient(135deg, ${theme.palette.accent?.main || theme.palette.secondary.main}, ${theme.palette.primary.main})`,
    },
  },
  ...sx,
}));

// Filter Panel
export const FilterPanelStyle = styled('div')(({ theme, sx }) => ({
  background: theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper,
  borderRadius: '16px',
  padding: '20px',
  border: `1px solid ${alpha(theme.palette.grey[500], 0.2)}`,
  boxShadow: `0px 4px 16px ${alpha(theme.palette.grey[500], 0.08)}`,
  '& .filter-section': {
    marginBottom: '20px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  '& .filter-title': {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  ...sx,
}));

export const GradientStyle = styled('div')(({ theme, sx }) => ({
  height: '100%',
  background: theme.palette.mode === 'light'
    ? `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(theme.palette.secondary.light, 0.1)} 50%, transparent 100%)`
    : `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.2)} 0%, ${alpha(theme.palette.secondary.dark, 0.2)} 50%, transparent 100%)`,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.gradients?.brand || theme.palette.gradients?.primary,
    opacity: 0.05,
    pointerEvents: 'none',
  },
  ...sx,
}));
  

export const IconifyLink = styled('a')(({ theme }) => (
    {
        textDecoration: 'none',
        cursor: "pointer",
        color: theme.palette.primary.main,
    }
));

export const BlankLink = styled('a')(({ theme, selected }) => (
    {
        textDecoration: selected ? 'underline' : 'none',
        cursor: "pointer",
        color: selected ? theme.palette.primary.main : theme.palette.text.primary,
    }
));

export const BackgroundImageStyle = styled('div')(({ theme, sx }) => (
    {
        ...sx,
        display: 'flex',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }
));

export const ToggleButton = styled('div')(({ theme, selected }) => ({
  padding: '12px 0',
  textAlign: 'center',
  borderRadius: '8px',
  width: '100%',
  background: selected 
    ? theme.palette.gradients?.brand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`
    : theme.palette.mode === 'light' ? '#f8fafc' : theme.palette.grey[800],
  cursor: 'pointer',
  color: selected 
    ? 'white' 
    : theme.palette.text.primary,
  boxShadow: selected
    ? `0px 8px 24px ${alpha(theme.palette.primary.main, 0.24)}`
    : `0px 2px 8px ${alpha(theme.palette.grey[500], 0.12)}`,
  border: `1px solid ${selected 
    ? 'transparent' 
    : alpha(theme.palette.grey[500], 0.2)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  fontWeight: selected ? 600 : 500,
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: selected
      ? `0px 12px 32px ${alpha(theme.palette.primary.main, 0.32)}`
      : `0px 8px 16px ${alpha(theme.palette.grey[500], 0.16)}`,
  },
}));

export const SelectStyle = styled('select')(({ theme,sx}) => (
    {
        outline: 'none',
        border: '1px solid #E5E5E5',
        borderRadius: '8px',
        padding: '12px',
        fontSize: '16px',
        fontWeight: 400,
        color: '#868686',
        ...sx,
    }
));

export const SearchBar = styled('div')(({ theme, sx }) => ({
  borderRadius: 12,
  display: 'flex',
  justifyContent: 'space-between',
  overflow: 'hidden',
  boxShadow: `0px 4px 16px ${alpha(theme.palette.primary.main, 0.08)}`,
  border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:focus-within': {
    boxShadow: `0px 8px 24px ${alpha(theme.palette.primary.main, 0.16)}`,
    borderColor: theme.palette.primary.main,
  },
  '& input': {
    border: 'none',
    width: '100%',
    padding: '12px 16px',
    fontSize: '14px',
    background: 'transparent',
    color: theme.palette.text.primary,
    '&:focus, &:active': {
      outline: 'none',
    },
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
  },
  '& button': {
    background: theme.palette.gradients?.brand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    border: 'none',
    padding: '12px 20px',
    color: 'white',
    cursor: 'pointer',
    fontWeight: 600,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: `0px 4px 12px ${alpha(theme.palette.primary.main, 0.24)}`,
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
  ...sx,
}));

export const RootStyle = styled('div')(({ theme, sx }) => ({
  background: theme.palette.mode === 'light'
    ? `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`
    : `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
  display: 'flex',
  flexDirection: 'column',
  gap: '4rem',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `radial-gradient(circle at 30% 20%, ${alpha('#ffffff', 0.1)} 0%, transparent 50%)`,
    pointerEvents: 'none',
  },
  ...sx,
}));

export const TableStyle = styled('table')(({ theme, sx }) => ({
  width: '100%',
  color: theme.palette.text.primary,
  borderRadius: 12,
  overflow: 'hidden',
  boxShadow: `0px 8px 32px ${alpha(theme.palette.primary.main, 0.08)}`,
  '& thead tr th': {
    borderTop: 'none',
    borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
    background: theme.palette.gradients?.brand || `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    fontWeight: 600,
    fontSize: 14,
    color: 'white',
    verticalAlign: 'bottom',
    padding: '1rem',
    textAlign: 'left',
  },
  '& tbody tr': {
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
      color: theme.palette.primary.main,
    },
  },
  '& tbody tr td': {
    background: theme.palette.background.paper,
    padding: '12px 16px',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.1)}`,
    verticalAlign: 'middle',
    cursor: 'pointer',
    fontSize: 14,
  },
  '& tbody tr td img': {
    height: 40,
    borderRadius: 8,
    verticalAlign: 'middle',
  },
  ...sx,
}));
export const NormalTableStyle = styled('table')(({ theme, sx }) => ({
  width: '100%',
  borderRadius: 12,
  overflow: 'hidden',
  background: alpha(theme.palette.background.paper, 0.9),
  boxShadow: `0px 4px 16px ${alpha(theme.palette.grey[500], 0.08)}`,
  border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
  '& thead tr th': {
    borderTop: 'none',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.2)}`,
    borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
    background: alpha(theme.palette.grey[100], 0.8),
    fontWeight: 600,
    fontSize: 14,
    verticalAlign: 'bottom',
    padding: '12px 16px',
    cursor: 'pointer',
    color: theme.palette.text.primary,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  },
  '& tbody tr': {
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.02),
    },
  },
  '& tbody tr td': {
    padding: '10px 16px',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.08)}`,
    borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.08)}`,
    verticalAlign: 'middle',
    fontSize: 13,
    color: theme.palette.text.primary,
  },
  '& tbody tr td:first-of-type, & thead tr th:first-of-type': {
    borderLeft: 'none',
  },
  '& tbody tr td img': {
    height: 40,
    borderRadius: 8,
    verticalAlign: 'middle',
  },
  ...sx,
}));

export default {
  NFTCardStyle,
  TradingPanelStyle,
  MarketplaceStyle,
  PriceTagStyle,
  BlockchainBadgeStyle,
  TradingButtonStyle,
  CollectionHeaderStyle,
  StatsCardStyle,
  NFTSearchBarStyle,
  FilterPanelStyle,
};